export default "__VITE_ASSET__3TZP$29W__"